export type EnvsRaw = Record<string, string>;
